export default "__VITE_ASSET__c0df404f__"